import './DeleteUnit.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import GoodsIn from '../../../../api/controllers/GoodsIn/GoodsIn';
import Error from '../../../../common/Error/Error';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';

// General DeleteUnit Component
const DeleteUnit = ({
  category,
  movementId,
  jobId,
  setModalOpen,
  refreshPackages,
  numOfPackages,
}) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();

  const deleteUnit = () => {
    setLoading(true);
    GoodsIn.updatePackageCount(category, movementId, jobId, numOfPackages)
      .then(() => {
        setLoading(false);
        refreshPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="cancel_movement_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="message">Are you sure that you want to delete this storage unit?</div>
      <div className="cancel_movement_buttons">
        <button className="cancel_button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>
        <button className="ok_button" onClick={() => deleteUnit()}>
          OK
        </button>
      </div>
    </div>
  );
};

DeleteUnit.propTypes = {
  category: PropTypes.string,
  movementId: PropTypes.number,
  setModalOpen: PropTypes.func,
  refreshPackages: PropTypes.func,
  jobId: PropTypes.number,
  numOfPackages: PropTypes.number,
};

export default DeleteUnit;
